// extracted by mini-css-extract-plugin
export default {"link":"donateButton-module__link___EzwDJ","donateButton":"donateButton-module__donateButton___uazWk"};